var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"yt_radio-label",class:{'yt_radio-label--disabled': _vm.disabled },on:{"click":_vm.onClick}},[_c('span',{staticClass:"yt_radio",class:{
      'yt_radio--active': _vm.isActive,
      'yt_radio--disabled': _vm.disabled,
      'yt_radio--checkbox': _vm.asCheckbox,
    },attrs:{"tabindex":"0"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }